<sm-title-bar [pageTitle]="pageTitle" [back]="true" > </sm-title-bar>
<!-- <mat-card appearance="outlined" >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="customerDueBookingList" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [itemsPerPage]="25">
      </sm-data-table>
    </div>
  </mat-card> -->
  
  <div class="customer_payment" *ngIf="!loader && customerDueBookingList.length > 0">

    <mat-card *ngFor="let data of customerDueBookingList" (click)="viewInvoice(data)">
  <div>
    <div class="plan-card" style="position: relative;" >
      <!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 10px;">
        <mat-icon>more_vert</mat-icon>
      </button> -->
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="viewInvoice(data)">
          <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
          <span>{{ 'customer_due_bookings.op2' | translate }}</span>
        </button>
      </mat-menu>
      <div class="d-flex " style="align-items: center;">
        <h2 class="plan-title"> {{data.inv_no}}</h2>
      </div>
      <p class="plan-info">
        <span class="label">Amount: </span> <span class="value">{{data.currency_symbol}}{{data.total_price.toFixed(2)}}</span>,
        <span class="label">Due: </span> <span class="value">{{data.currency_symbol}}{{data.payment_due.toFixed(2)}}</span>
      </p>
      <p class="plan-cost">
        <span class="value">{{data.creation_time | date}}, {{data.creation_time | date: 'shortTime' : 'UTC'}}</span>
      </p>
      <div class="arrow_due" >
            <mat-icon>arrow_forward</mat-icon>
          </div>
    </div>
  </div>
  </mat-card>
  </div>

  <div class="row" *ngIf="!loader && customerDueBookingList.length == 0">
    <div class="col-sm-12" >
      <div style="padding: 20px 18px 20px 18px;border-radius: var(--dra-radius-x-small);transition: 0.3s;">
        <div class="top_section_order">
          <div class="row">
           <div class="nal_rrty">
            <div style="text-align:center;min-height: 500px;padding-top: 210px">
            <div class="cv_notifia">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 456.212 456" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M415.008 1.59a9.95 9.95 0 0 0-5.223-1.485H111.996c-25.601 0-46.43 20.625-46.43 45.903l-1.75 256.441H10c-5.523 0-10 4.477-10 10v46.2c.035 33.925 27.527 61.417 61.453 61.456.688 0 1.379-.07 2.055-.21h248.457c1.48.105 2.973.175 4.476.175 34.454-.062 62.352-28 62.364-62.453V207.711h67.406c5.523 0 10-4.477 10-10V49.266c-.121-23.871-17.602-44.102-41.203-47.676zM20 358.652v-36.199h234.078v35.168a62.242 62.242 0 0 0 16.512 42.274H60.086c-.473.003-.941.039-1.406.109-21.754-1.48-38.653-19.547-38.68-41.352zM358.805 49.266v308.351a42.284 42.284 0 0 1-12.356 29.801 41.871 41.871 0 0 1-28.648 12.625 9.958 9.958 0 0 0-1.637-.145h-3.516c-21.78-2.144-38.425-20.386-38.57-42.273v-45.176c0-5.52-4.476-10-10-10H83.816l1.75-256.37c.145-14.462 11.965-26.083 26.43-25.974h256.742a47.735 47.735 0 0 0-9.933 29.16zM436.21 187.71h-57.406V49.266c.261-15.668 13.035-28.227 28.703-28.227s28.441 12.559 28.703 28.227zm0 0" fill="#7c7c7c" opacity="1" data-original="#000000"></path><path d="M128.387 108.441h94.71c5.524 0 10-4.476 10-10 0-5.523-4.476-10-10-10h-94.71c-5.524 0-10 4.477-10 10 0 5.524 4.476 10 10 10zM305.059 159.941H128.387c-5.524 0-10 4.477-10 10 0 5.52 4.476 10 10 10h176.672c5.523 0 10-4.48 10-10 0-5.523-4.477-10-10-10zM305.059 231.438H128.387c-5.524 0-10 4.48-10 10 0 5.523 4.476 10 10 10h176.672c5.523 0 10-4.477 10-10 0-5.52-4.477-10-10-10zm0 0" fill="#7c7c7c" opacity="1" data-original="#000000"></path></g></svg>
            </div>
            <div>
              <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
                There's no due payment to show here. Either all the payments are cleared or no invoice raised so far.
             </p>
           </div>
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>



  
  <!-- <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'customer_due_bookings.op1' | translate }}</span>
    </button>
    <button mat-menu-item (click)="openInvoice(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'customer_due_bookings.op2' | translate }}</span>
    </button>
  </ng-template> -->
  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->